import { SatRealScreen, type Callout } from '@/components/SatRealScreen';
import { SatScoreMockup } from '@/components/SatScoreMockup';

/** Real Screen 1 (spec 010 §5.4): the results after the diagnostic. */
const CALLOUTS: readonly Callout[] = [
  { title: 'All eight areas in one view', body: 'Reading and writing, and math, each shown from your own answers.' },
  { title: 'Weakest first', body: 'The area that needs the most work sits at the top. That is where practice starts.' },
  { title: 'One next step', body: 'A single button, never a menu of choices.' },
];

export function SatScoreTrackingSection() {
  return (
    <SatRealScreen
      id="results"
      title="Your results, area by area"
      lead="When the diagnostic ends, you see every area side by side. You know where you stand, and what to do next."
      callouts={CALLOUTS}
      caption="Example student results."
      layout="surface-left"
      tone="bg-background"
    >
      <SatScoreMockup />
    </SatRealScreen>
  );
}
